import EventManager from "../eventManager.js";

let instance = null;

export default class TestsManager extends EventManager {

    constructor() {
        super();
        this.tests = {};
    }

    setConfiguration(conf) { this.tests = conf; }

    getTest(serial) {

        if (serial === undefined) {
            return this.tests;
        } else if (serial in this.tests) {
            return this.tests[serial];
        }

        return 0;

    }
}
